"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var color_1 = require("../common/color");
var ScienceTabs = function (_a) {
    var data = _a.data, handleClickTab = _a.handleClickTab, tabIndex = _a.tabIndex, color = _a.color;
    var style = { borderColor: (0, color_1.toHex)(color), color: (0, color_1.toHex)(color) };
    return ((0, preact_1.h)("ul", { class: "science-tabs" }, data.tabs.map(function (tab, index) { return ((0, preact_1.h)("li", { class: "science-tabs__tab", key: index, onClick: function () { return handleClickTab(index); }, style: tabIndex === index
            ? __assign(__assign({}, style), { backgroundColor: (0, color_1.toHex)(color), color: '#ffffff' }) : style }, tab.title)); })));
};
exports.default = ScienceTabs;
